'use client';

import * as React from 'react';
export const EventTimelinePremiumStyledContext = /*#__PURE__*/React.createContext(null);
if (process.env.NODE_ENV !== "production") EventTimelinePremiumStyledContext.displayName = "EventTimelinePremiumStyledContext";
export function useEventTimelinePremiumStyledContext() {
  const value = React.useContext(EventTimelinePremiumStyledContext);
  if (!value) {
    throw /* FIXME (minify-errors-in-prod): Unminified error message in production build! */new Error('MUI X: useEventTimelinePremiumStyledContext must be used within EventTimelinePremiumStyledContext.Provider');
  }
  return value;
}